import { useIds as a } from "@chakra-ui/hooks";
import { mergeRefs as l } from "@chakra-ui/react-utils";
import { useRef as f, useState as b, useCallback as m } from "react";
function I({ id: t }) {
  const [e, s] = a(
    t,
    "odi-subHeader",
    "odi-subHeader--title"
  ), r = f(null), [o, u] = b(!1), d = m(
    (i = {}, n = null) => ({
      ...i,
      ref: l(n, r),
      id: e,
      tabIndex: -1
    }),
    [e]
  );
  return {
    titleId: s,
    getSubHeaderProps: d,
    isTitleMounted: o,
    setTitleMounted: u
  };
}
export {
  I as useSubHeader
};
